
<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="my-3 mx-2">
            <div class="d-flex align-items-center my-1">
                <div class="mx-2 h3">Services</div>
                <router-link to="/services/add">
                    <button class="btn btn-sm border border-primary text-primary" v-if="permissions.ADD_CONTENT == 'Y'">
                        Add New Service
                    </button>
                </router-link>
            </div>
            <AllElements category_id="2" editLink="services"></AllElements>
        </div>
    </div>
</template>
<script>
import AllElements from "@/components/ElementComponents/AllElements";

export default {
    created() {
        this.permissions = JSON.parse(localStorage.getItem("permissions"));
    },
    data() {
        return {
            permissions: {},
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'Services',
                    to: '/services/all'
                }, {
                    text: 'All Services',
                    to: '/services/all'
                }
            ],
        }
    },
    setup() { },
    components: {
        AllElements,
    },
};
</script>